<div cdkDrag [cdkDragData]="data">
    <div [ngClass]="data.placeholderClassName" *cdkDragPlaceholder></div>
    <div [id]="data.id" class="section-area"
        tabindex="4" (keyup.Space)="onSelect($event)"
        [ngClass]="data.isSelected ? 'section-selected' : (data.isContainerExpanded ? 'section-expanded' : 'section-unselected')"
        cdkDropList [cdkDropListConnectedTo]="dropListIds" [cdkDropListData]="data.children"
        [cdkDropListEnterPredicate]="isDroppableWidget" (cdkDropListDropped)="onDrop($event)">
        <!-- Titlebar for Widget -->
        <div class="section-top-bar" fxLayout="row nowrap" fxLayoutAlign="end start">
            <!-- <mat-icon class="drag-handler" cdkDragHandle [matBadge]="data.badge">{{data.icon}}</mat-icon> -->
            <mat-icon class="drag-handler" cdkDragHandle>drag_indicator</mat-icon>
            <mat-label class="section-title" fxFlex="grow" (click)="onSelect($event)"
                title="{{data.description?data.description:data.label}}">
                <span *ngIf="!data.seqHidden">{{ data.seq | prettySectionSequence }}. </span>{{data.label}}
            </mat-label>
            <!-- <mat-icon *ngIf="data.isSelected" class="top-icon">check</mat-icon> -->
            <mat-icon class="top-icon" (click)="onDeleteModal()">delete</mat-icon>
            <!-- <mat-icon *ngIf="!isMinimized" class="top-icon" (click)="onMinimize()">expand_less</mat-icon> -->
            <!-- <mat-icon *ngIf="isMinimized" class="top-icon" (click)="onMaximize()">expand_more</mat-icon> -->
            <mat-icon *ngIf="!data.isContainerExpanded" class="top-icon" (click)="onSectionExpand()">expand_more</mat-icon>
            <mat-icon *ngIf="data.isContainerExpanded" class="top-icon" (click)="onSectionCollapse()">expand_less</mat-icon>
        </div>

        <!-- Config data for Widget -->
        <div *ngIf="!isMinimized" fxLayout="row nowrap">
            <appMetadataSection fxFlex="grow" [data]="tempData" [isEdit]="true"></appMetadataSection>
        </div>

        <!-- Area for children drop -->
        <div *ngIf="data.isContainerExpanded" class="section-drop-area">
            <ng-container *ngFor="let widget of data.children">
                <ng-container [ngSwitch]="widget.widgetType">
                    <!-- For now don't allow dropping sections into sections
                    -->
                    <div appWidgetsSection [data]="$any(widget)" [dropListIds]="dropListIds"
                        (dropListIdAdded)="onDropListIdAdded($event)" *ngSwitchCase="WidgetsTypeEnum.SECTION">
                    </div>

                    <div appWidgetsQuestion [data]="$any(widget)" *ngSwitchCase="WidgetsTypeEnum.QUESTION">
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </div>
</div>